import React from 'react';
import {Table} from "reactstrap";

class SalesTimeframeTable extends React.Component {

    leadSourceName = (value) => {
        var nv = parseInt(value);
        if (isNaN(nv)) {
            return "Empty"
        }
        switch(nv) {
            case 40:
                return "ASQ";
            case 42:
                return "Solar Market";
            case 43:
                return "PBBB";
            case 44:
                return "Doors";
            case 45:
                return "GenRev";
            case 46:
                return "EMBR";
            case 47:
                return "Smart Connections";
            case 89:
                return "Facebook";
            case 145:
                return "EMBR #2";
            case 148:
                return "Glengarry";
            case 153:
                return "Glengarry #2";
            case 177:
                return "Starservice";
            case 178:
                return "Text Lead";
            case 179:
                return "Solar Restor";
            case 189:
                return "GenRev #2";
            case 190:
                return "Self Generated";
            case 191:
                return "ONLC";
            case 206:
                return "Stellar";
            case 207:
                return "Ambrosius";
            case 224:
                return "EM";
            case 225:
                return "ASQ";
            case 226:
                return "PLE";
            case 227:
                return "Inbound Call";
            case 228:
                return "Referral";
            case 230:
                return "Inbound Web";
            case 231:
                return "EMBR2018";
            case 276:
                return "Hubspot";
            case 277:
                return "Clickfunnels";
            case 286:
                return "FunnelClicks";
            case 295:
                return "Albany Fair";
            case 341:
                return "MAD";
            case 342:
                return "CF2";
            case 375:
                return "Aumentoo";
            case 398:
                return "Digiamigo";
            case 399:
                return "Vencore";
            case 422:
                return "Clickfunnels2";
            case 484:
                return "Bill Boards";
            case 485:
                return "KGB";
            case 486:
                return "BOQ";
            case 525:
            case 526:
                return "Wolf";
            case 533:
                return "GTB";
            case 543:
                return "COSTCO KIOSK";
            case 544:
                return "Rokkit2";
            case 548:
                return "MOB";
            case 549:
                return "FIRE";
            case 575:
                return "RokkitCOM";
            case 577:
                return "Rokkit3";
            case 578:
                return "JuicyFire";
            case 589:
                return "RokkitNative";
            case 590:
                return "RW";
            case 596:
                return "ST";
            case 597:
                return "JT";
            case 600:
                return "BF";
            case 608:
                return "CDR";
            case 613:
                return "BYB";
            case 617:
                return "ES";
            case 618:
                return "CCD";
            case 622:
                return "JACK";
            case 623:
                return "InboundBranded";
            case 630:
                return "AMP";
            case 631:
                return "REV";
            case 633:
                return "VAN";
            case 634:
                return "SS";
            case 635:
                return "FRO";
            case 636:
                return "VER2";
            case 660:
                return "VEN";
            default:
                return value;
        }
    }

    getData = () => {
        if (this.props.data.length == 0) {
            return []
        }
        var d = [];
        switch(this.props.view) {
            case 'rep':
                var repids = Array.from(new Set(this.props.data.map((item) => item.RepID)))
                repids.forEach(rid => {
                    var sd = this.props.data.filter(item => item.RepID == rid)
                    var avg = sd.reduce((a, b) => (a + b.AppToSale), 0) / sd.length;
                    avg = parseInt(avg * 100) / 100;
                    var rep = this.props.reps.filter(item => item.ExternalUserID == rid);
                    var repName = 'Unknown';
                    if (rep.length > 0) {
                        repName = rep[0].UserName;
                    }
                    d.push(
                        {
                            Name: repName,
                            Value: avg + ' days'
                        }
                    );
                });
                d.sort((a, b) => {
                    return a.Name < b.Name ? -1 : (a.Name > b.Name ? 1 : 0);
                })
                return d;
            case 'state':
                var states = Array.from(new Set(this.props.data.map((item) => item.State)))
                states.forEach(sid => {
                    var sd = this.props.data.filter(item => item.State == sid)
                    var avg = sd.reduce((a, b) => (a + b.AppToSale), 0) / sd.length;
                    avg = parseInt(avg * 100) / 100;
                    d.push(
                        {
                            Name: sid,
                            Value: avg + ' days'
                        }
                    );
                });
                d.sort((a, b) => {
                    return a.Name < b.Name ? -1 : (a.Name > b.Name ? 1 : 0);
                })
                return d;
            case 'ls':
                var sources = Array.from(new Set(this.props.data.map((item) => item.LeadSource)))
                sources.forEach(sid => {
                    var sd = this.props.data.filter(item => item.LeadSource == sid)
                    var avg = sd.reduce((a, b) => (a + b.AppToSale), 0) / sd.length;
                    avg = parseInt(avg * 100) / 100;
                    d.push(
                        {
                            Name: this.leadSourceName(sid),
                            Value: avg + ' days'
                        }
                    );
                });
                d.sort((a, b) => {
                    return a.Name < b.Name ? -1 : (a.Name > b.Name ? 1 : 0);
                })
                return d;
            default:
                var avg = this.props.data.reduce((a, b) => (a + b.AppToSale), 0) / this.props.data.length;
                avg = parseInt(avg * 100) / 100;
                return [
                    {
                        Name: 'All',
                        Value: avg + ' days'
                    }
                ]
        }

    }

    render() {
        const data = this.getData()
        return (
            <>
                <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                    <tr>
                        <th>&nbsp;</th>
                        <th className={`text-center`}>Average Time</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.map(d => {
                        return (
                            <tr key={d.Name}>
                                <td>{d.Name}</td>
                                <td className={`text-center`}>{d.Value}</td>
                            </tr>
                        )
                    })}

                    </tbody>
                </Table>
            </>
        )
    }
}

export default SalesTimeframeTable;